import { render, staticRenderFns } from "./assignmentlist.html?vue&type=template&id=9169758a&"
import script from "./assignmentlist.js?vue&type=script&lang=js&"
export * from "./assignmentlist.js?vue&type=script&lang=js&"
import style0 from "./assignmentlist.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports